import React, { useMemo } from 'react';
import Icon from '../../../components/AppIcon';
import { api } from '../../../lib/api';

function extLower(name: string): string {
  const n = (name || '').toLowerCase();
  const idx = n.lastIndexOf('.');
  return idx >= 0 ? n.slice(idx + 1) : '';
}

function isImageExt(ext: string): boolean {
  return ['png', 'jpg', 'jpeg', 'gif', 'webp', 'bmp', 'svg'].includes(ext);
}

function backgroundFromSeed(seed: string): string {
  const s = (seed || 'educonnect').toLowerCase();
  let h = 0;
  for (let i = 0; i < s.length; i++) h = (h * 31 + s.charCodeAt(i)) % 360;
  const h2 = (h + 32) % 360;
  return `linear-gradient(135deg, hsl(${h} 70% 55% / 0.25), hsl(${h2} 70% 55% / 0.15))`;
}

export default function LibraryCover({
  title,
  category,
  originalName,
  fileUrl,
}: {
  title: string;
  category?: string | null;
  originalName: string;
  fileUrl: string;
}) {
  const ext = extLower(originalName);
  const isImg = isImageExt(ext);

  const fullUrl = useMemo(() => {
    const base = String((api.defaults.baseURL || window.location.origin) as any).replace(/\/$/, '');
    const u = (fileUrl || '').trim();
    if (!u) return '';
    return `${base}${u.startsWith('/') ? u : `/${u}`}`;
  }, [fileUrl]);

  if (isImg && fullUrl) {
    return (
      <div className="w-20 sm:w-24 aspect-[3/4] rounded-lg overflow-hidden border border-border bg-muted flex-shrink-0">
        <img src={fullUrl} alt={title} className="w-full h-full object-cover" loading="lazy" />
      </div>
    );
  }

  return (
    <div
      className="w-20 sm:w-24 aspect-[3/4] rounded-lg overflow-hidden border border-border bg-card flex-shrink-0 relative"
      style={{ backgroundImage: backgroundFromSeed(category || title) }}
      aria-label="Copertă"
    >
      <div className="absolute inset-0 p-3 flex flex-col justify-between">
        <div className="flex items-center justify-between">
          <div className="w-8 h-8 rounded-md bg-primary/10 flex items-center justify-center">
            <Icon name="Book" size={16} className="text-primary" />
          </div>
          <div className="text-[10px] text-muted-foreground">{ext ? ext.toUpperCase() : 'FILE'}</div>
        </div>
        <div className="text-[10px] text-muted-foreground line-clamp-2">{category || 'Resursă'}</div>
      </div>
    </div>
  );
}

